// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import classnames from 'classnames';
import {Link, NavLink} from 'react-router-dom';
import {get} from 'lodash';

// Components
import NavDropdown from '../../core/nav-dropdown';
import Permissions from '../../core/permissions';

// Styles
import './main-nav.scss';

class MainNav extends Component {
    getAdminDropdownProps() {
        return {
            activeClassName: 'main-nav--link_active',
            activePaths: ['/admin', '/audits', '/map-external-networks', '/networks', '/providers', '/rules', '/roles'],
            className: 'main-nav--dropdown',
            dropdownRenderer: this.renderAdminDropdownItems,
        };
    }

    getClass() {
        const {className} = this.props;

        return classnames(className, 'main-nav');
    }

    getInvestigationDropdownProps() {
        return {
            activeClassName: 'main-nav--link_active',
            activePaths: [
                '/investigation/mass-action-results',
                '/investigation/violations',
                '/investigation/flagged-metadata',
            ],
            className: 'main-nav--dropdown',
            dropdownRenderer: this.renderInvestigationDropdownItems,
        };
    }

    getMediaItemsDropdownProps() {
        return {
            activeClassName: 'main-nav--link_active',
            activePaths: ['/media-items', '/investigation/enhanced-view'],
            className: 'main-nav--dropdown',
            dropdownRenderer: this.renderMeidaItemsDropdownItems,
        };
    }

    getDisplayPathDropdownProps() {
        return {
            activeClassName: 'main-nav--link_active',
            activePaths: ['/display-paths', '/display-path-modifiers'],
            className: 'main-nav--dropdown',
            dropdownRenderer: this.renderDisplayPathDropdownItems,
        };
    }

    getLinkProps = ({isActive}) => ({
        className: classnames(
            {
                'main-nav--link_active': isActive,
            },
            'main-nav--link',
            'button'
        ),
    });

    renderAdminDropdownItems = () => (
        <ul className="main-nav--dropdown">
            <Permissions accessRequirement="update" elementService="network" requiresServiceAccess={true}>
                <li>
                    <Link to="/map-external-networks">Map External Networks</Link>
                </li>
            </Permissions>
            <Permissions accessRequirement="read" elementService="network" requiresServiceAccess={true}>
                <li>
                    <Link to="/networks">Networks</Link>
                </li>
            </Permissions>
            <Permissions accessRequirement="read" elementService="provider" requiresServiceAccess={true}>
                <li>
                    <Link to="/providers">Providers</Link>
                </li>
            </Permissions>
            <Permissions accessRequirement="update" elementService="vfb" requiresServiceAccess={true}>
                <li>
                    <Link to="/vfb">VFB</Link>
                </li>
            </Permissions>
            <Permissions adminOnly={true}>
                <li>
                    <Link to="/rules">Rules</Link>
                </li>
            </Permissions>
            <Permissions adminOnly={true}>
                <li>
                    <Link to="/admin/users">Users</Link>
                </li>
            </Permissions>
            <Permissions adminOnly={true}>
                <li>
                    <Link to="/roles">Roles</Link>
                </li>
            </Permissions>
            <Permissions adminOnly={true}>
                <li>
                    <Link to="/admin/health">Health</Link>
                </li>
            </Permissions>
            <Permissions accessRequirement="read" elementService="est" requiresServiceAccess={true}>
                <li>
                    <Link to="/admin/earl">Earl (Avails Management Tool)</Link>
                </li>
            </Permissions>
        </ul>
    );

    renderDisplayPathDropdownItems = () => (
        <ul className="main-nav--dropdown">
            <Permissions allowRoles={['networkDisplayPath_read', 'networkDisplayPath_delete']}>
                <li>
                    <Link to="/display-paths">Display Paths</Link>
                </li>
            </Permissions>
            <Permissions allowRoles={['networkDisplayPathModifier_read', 'networkDisplayPathModifier_delete']}>
                <li>
                    <Link to="/display-path-modifiers">Display Path Modifiers</Link>
                </li>
            </Permissions>
        </ul>
    );

    renderInvestigationDropdownItems = () => (
        <ul className="main-nav--dropdown">
            <li>
                <Link to="/investigation/mass-action-results">Mass Action Results</Link>
            </li>
            <li>
                <Link to="/investigation/violations">Violations</Link>
            </li>
            <li>
                <Link to="/investigation/flagged-metadata">Flagged Metadata</Link>
            </li>
        </ul>
    );

    renderMeidaItemsDropdownItems = () => (
        <ul className="main-nav--dropdown">
            <li>
                <Link to="/media-items">Media Items/Mapping</Link>
            </li>
            <li>
                <Link to="/investigation/enhanced-view">Enhanced View</Link>
            </li>
        </ul>
    );

    render() {
        return (
            <nav className={this.getClass()}>
                <NavDropdown {...this.getMediaItemsDropdownProps()}>Media Items/Views</NavDropdown>
                <NavLink
                    to="/movies-and-programs"
                    className={(props) => this.getLinkProps(props).className}
                >
                  Movies and Programs
                </NavLink>

                <NavDropdown {...this.getInvestigationDropdownProps()}>Investigation</NavDropdown>
                <Permissions>
                    <NavDropdown {...this.getAdminDropdownProps()}>Admin</NavDropdown>
                </Permissions>
                <Permissions
                    allowRoles={[
                        'networkDisplayPath_read',
                        'networkDisplayPath_delete',
                        'networkDisplayPathModifier_read',
                        'networkDisplayPathModifier_delete',
                    ]}
                >
                    <NavDropdown {...this.getDisplayPathDropdownProps()}>Network Display Paths</NavDropdown>
                </Permissions>
            </nav>
        );
    }
}

MainNav.propTypes = {
    className: PropTypes.string,
    routerParams: PropTypes.object,
};

const mapStateToProps = (state) => ({
    routerParams: get(state.router, 'routerParams', {}),
});

export default connect(mapStateToProps, null)(MainNav);
